(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["community-discussion-article-content"]) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-community-article-carousel]');
    if (!carousels.length) return;

    carousels.forEach((carousel) => {
      const viewport = carousel.querySelector('[data-carousel-viewport]');
      const track = carousel.querySelector('[data-carousel-track]');
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');
      const dots = carousel.querySelectorAll('[data-carousel-dot]');
      const imageTriggers = carousel.querySelectorAll('[data-carousel-image-trigger]');
      const lightbox = carousel.querySelector('[data-carousel-lightbox]');
      const lightboxStage = carousel.querySelector('[data-lightbox-stage]');
      const lightboxImage = carousel.querySelector('[data-lightbox-image]');
      const lightboxClose = carousel.querySelector('[data-lightbox-close]');
      const lightboxPrev = carousel.querySelector('[data-lightbox-prev]');
      const lightboxNext = carousel.querySelector('[data-lightbox-next]');
      const zoomInBtn = carousel.querySelector('[data-lightbox-zoom-in]');
      const zoomOutBtn = carousel.querySelector('[data-lightbox-zoom-out]');
      const resetBtn = carousel.querySelector('[data-lightbox-reset]');
      if (!viewport || !track || !prevBtn || !nextBtn) return;

      const slides = track.querySelectorAll('[data-carousel-slide]');
      const total = slides.length;
      if (!total) return;
      const lightboxSources = Array.from(imageTriggers).map((trigger) => ({
        src: trigger.dataset.fullSrc || '',
        alt: trigger.dataset.alt || ''
      }));
      const lightboxState = {
        active: false,
        index: 0,
        scale: 1,
        x: 0,
        y: 0,
        dragging: false,
        pointerId: null,
        startX: 0,
        startY: 0,
        startOffsetX: 0,
        startOffsetY: 0
      };

      const getIndex = () => {
        const width = viewport.clientWidth || 1;
        return Math.round(viewport.scrollLeft / width);
      };

      const clampIndex = (index) => Math.max(0, Math.min(total - 1, index));

      const update = () => {
        const index = clampIndex(getIndex());
        prevBtn.disabled = index <= 0;
        nextBtn.disabled = index >= total - 1;
        dots.forEach((dot) => {
          const dotIndex = Number(dot.dataset.index || 0);
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      };

      const goTo = (index) => {
        const nextIndex = clampIndex(index);
        viewport.scrollTo({ left: viewport.clientWidth * nextIndex, behavior: 'smooth' });
      };

      const clampOffset = () => {
        if (!lightboxStage || !lightboxImage) return;
        const stageRect = lightboxStage.getBoundingClientRect();
        const naturalWidth = lightboxImage.naturalWidth || 1;
        const naturalHeight = lightboxImage.naturalHeight || 1;
        const fitScale = Math.min(stageRect.width / naturalWidth, stageRect.height / naturalHeight);
        const baseWidth = naturalWidth * fitScale;
        const baseHeight = naturalHeight * fitScale;
        const scaledWidth = baseWidth * lightboxState.scale;
        const scaledHeight = baseHeight * lightboxState.scale;
        const maxX = Math.max(0, (scaledWidth - stageRect.width) / 2);
        const maxY = Math.max(0, (scaledHeight - stageRect.height) / 2);
        lightboxState.x = Math.max(-maxX, Math.min(maxX, lightboxState.x));
        lightboxState.y = Math.max(-maxY, Math.min(maxY, lightboxState.y));
      };

      const applyTransform = () => {
        if (!lightboxImage) return;
        clampOffset();
        lightboxImage.style.transform = `translate(${lightboxState.x}px, ${lightboxState.y}px) scale(${lightboxState.scale})`;
      };

      const setScale = (scale) => {
        lightboxState.scale = Math.max(1, Math.min(4, scale));
        if (lightboxState.scale === 1) {
          lightboxState.x = 0;
          lightboxState.y = 0;
        }
        applyTransform();
      };

      const setLightboxImage = (index) => {
        if (!lightboxImage || !lightboxSources.length) return;
        const safeIndex = ((index % lightboxSources.length) + lightboxSources.length) % lightboxSources.length;
        lightboxState.index = safeIndex;
        const source = lightboxSources[safeIndex];
        lightboxImage.src = source.src;
        lightboxImage.alt = source.alt;
        lightboxState.scale = 1;
        lightboxState.x = 0;
        lightboxState.y = 0;
        lightboxImage.onload = () => applyTransform();
      };

      const openLightbox = (index) => {
        if (!lightbox || !lightboxImage || !lightboxSources.length) return;
        setLightboxImage(index);
        lightbox.hidden = false;
        lightboxState.active = true;
        document.documentElement.style.overflow = 'hidden';
      };

      const closeLightbox = () => {
        if (!lightbox) return;
        lightbox.hidden = true;
        lightboxState.active = false;
        lightboxState.dragging = false;
        lightboxStage?.classList.remove('is-dragging');
        document.documentElement.style.overflow = '';
      };

      prevBtn.addEventListener('click', () => goTo(getIndex() - 1));
      nextBtn.addEventListener('click', () => goTo(getIndex() + 1));
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const targetIndex = Number(dot.dataset.index || 0);
          goTo(targetIndex);
        });
      });
      viewport.addEventListener('scroll', () => window.requestAnimationFrame(update), { passive: true });
      viewport.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(getIndex() - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(getIndex() + 1);
        }
      });
      imageTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const index = Number(trigger.dataset.index || 0);
          openLightbox(index);
        });
      });
      lightboxClose?.addEventListener('click', closeLightbox);
      lightboxPrev?.addEventListener('click', () => setLightboxImage(lightboxState.index - 1));
      lightboxNext?.addEventListener('click', () => setLightboxImage(lightboxState.index + 1));
      zoomInBtn?.addEventListener('click', () => setScale(lightboxState.scale + 0.25));
      zoomOutBtn?.addEventListener('click', () => setScale(lightboxState.scale - 0.25));
      resetBtn?.addEventListener('click', () => setScale(1));

      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });

      lightboxStage?.addEventListener(
        'wheel',
        (event) => {
          event.preventDefault();
          const zoomDelta = event.deltaY < 0 ? 0.2 : -0.2;
          setScale(lightboxState.scale + zoomDelta);
        },
        { passive: false }
      );
      lightboxStage?.addEventListener('pointerdown', (event) => {
        if (lightboxState.scale <= 1) return;
        lightboxState.dragging = true;
        lightboxState.pointerId = event.pointerId;
        lightboxState.startX = event.clientX;
        lightboxState.startY = event.clientY;
        lightboxState.startOffsetX = lightboxState.x;
        lightboxState.startOffsetY = lightboxState.y;
        lightboxStage.classList.add('is-dragging');
        lightboxStage.setPointerCapture(event.pointerId);
      });
      lightboxStage?.addEventListener('pointermove', (event) => {
        if (!lightboxState.dragging || event.pointerId !== lightboxState.pointerId) return;
        const deltaX = event.clientX - lightboxState.startX;
        const deltaY = event.clientY - lightboxState.startY;
        lightboxState.x = lightboxState.startOffsetX + deltaX;
        lightboxState.y = lightboxState.startOffsetY + deltaY;
        applyTransform();
      });
      const stopDragging = () => {
        lightboxState.dragging = false;
        lightboxState.pointerId = null;
        lightboxStage?.classList.remove('is-dragging');
      };
      lightboxStage?.addEventListener('pointerup', stopDragging);
      lightboxStage?.addEventListener('pointercancel', stopDragging);
      lightboxStage?.addEventListener('dblclick', () => {
        if (lightboxState.scale > 1) {
          setScale(1);
          return;
        }
        setScale(2);
      });

      window.addEventListener('keydown', (event) => {
        if (!lightboxState.active) return;
        if (event.key === 'Escape') {
          closeLightbox();
        }
        if (event.key === 'ArrowLeft') {
          setLightboxImage(lightboxState.index - 1);
        }
        if (event.key === 'ArrowRight') {
          setLightboxImage(lightboxState.index + 1);
        }
        if (event.key === '+' || event.key === '=') {
          setScale(lightboxState.scale + 0.25);
        }
        if (event.key === '-' || event.key === '_') {
          setScale(lightboxState.scale - 0.25);
        }
      });

      new ResizeObserver(update).observe(viewport);
      new ResizeObserver(() => {
        if (lightboxState.active) applyTransform();
      }).observe(document.body);
      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goddess-space-audio-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('[data-goddess-audio-grid]');
    if (!sections.length) return;

    sections.forEach((section) => {
      if (section.dataset.goddessAudioGridReady === 'true') return;
      section.dataset.goddessAudioGridReady = 'true';

      const filterButtons = section.querySelectorAll('[data-filter-value]');
      const cards = section.querySelectorAll('[data-audio-card]');
      const audio = section.querySelector('[data-audio-player]');
      const vipModal = document.getElementById(section.dataset.vipModalId || '');
      const vipModalCloseBtn = document.getElementById(section.dataset.vipModalCloseId || '');
      const loginModal = document.getElementById(section.dataset.loginModalId || '');
      const loginModalCloseBtn = document.getElementById(section.dataset.loginModalCloseId || '');
      if (!audio) return;

      let currentButton = null;
      let currentUrl = '';
      const isLoggedIn = section.dataset.isLoggedIn === 'true';
      
      const showVipModal = () => {
        if (!vipModal) return;
        vipModal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      };

      const showLoginModal = () => {
        if (!loginModal) return;
        loginModal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
      };

      const hideVipModal = () => {
        if (!vipModal) return;
        vipModal.style.display = 'none';
        document.body.style.overflow = '';
      };

      const hideLoginModal = () => {
        if (!loginModal) return;
        loginModal.style.display = 'none';
        document.body.style.overflow = '';
      };

      const handleLockedAudio = () => {
        if (!isLoggedIn) {
          showLoginModal();
          return;
        }
        showVipModal();
      };

      const stopCurrent = () => {
        if (currentButton) currentButton.classList.remove('is-playing');
        audio.pause();
        currentButton = null;
        currentUrl = '';
      };

      const updateFilter = (value) => {
        cards.forEach((card) => {
          const cardCategory = (card.dataset.category || '').toLowerCase();
          const visible = value === 'all' || cardCategory === value;
          card.classList.toggle('is-hidden', !visible);
        });
      };

      filterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = (button.dataset.filterValue || 'all').toLowerCase();
          filterButtons.forEach((item) => {
            const isActive = item === button;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          });
          updateFilter(value);
        });
      });

      section.addEventListener('click', (event) => {
        const button = event.target.closest('[data-audio-play]');
        if (!button || button.disabled) return;
        const card = button.closest('[data-audio-card]');
        if (card && card.dataset.audioLocked === 'true') {
          handleLockedAudio();
          return;
        }

        const audioUrl = button.dataset.audioUrl || '';
        if (!audioUrl) return;

        if (currentButton === button) {
          if (audio.paused) {
            audio.play().catch(() => {});
          } else {
            audio.pause();
          }
          return;
        }

        if (currentUrl !== audioUrl) {
          audio.src = audioUrl;
          currentUrl = audioUrl;
        }

        if (currentButton && currentButton !== button) {
          currentButton.classList.remove('is-playing');
        }

        audio.play().then(() => {
          currentButton = button;
          currentButton.classList.add('is-playing');
        }).catch(() => {
          if (currentButton) currentButton.classList.remove('is-playing');
        });
      });

      audio.addEventListener('ended', stopCurrent);
      audio.addEventListener('pause', () => {
        if (!audio.ended && currentButton) {
          currentButton.classList.remove('is-playing');
        }
      });
      audio.addEventListener('play', () => {
        if (currentButton) currentButton.classList.add('is-playing');
      });

      vipModalCloseBtn?.addEventListener('click', hideVipModal);
      loginModalCloseBtn?.addEventListener('click', hideLoginModal);
      if (vipModal) {
        vipModal.addEventListener('click', (event) => {
          if (event.target === vipModal || event.target.classList.contains('modal-popup__overlay')) {
            hideVipModal();
          }
        });
      }
      if (loginModal) {
        loginModal.addEventListener('click', (event) => {
          if (event.target === loginModal || event.target.classList.contains('modal-popup__overlay')) {
            hideLoginModal();
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-comments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.querySelectorAll('[data-mo-comments-root]');
    if (!roots || !roots.length) return;

    var mobileMq = null;
    try {
      mobileMq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    } catch (e) {
      mobileMq = null;
    }

    function toDate(value) {
      if (!value) return null;
      var d = new Date(value);
      if (String(d) === 'Invalid Date') return null;
      return d;
    }

    function byCreatedAt(sort) {
      var dir = sort === 'oldest' ? 1 : -1;
      return function (a, b) {
        var da = toDate(a.created_at);
        var db = toDate(b.created_at);
        var ta = da ? da.getTime() : 0;
        var tb = db ? db.getTime() : 0;
        if (ta === tb) return 0;
        return ta > tb ? dir : -dir;
      };
    }

    function getInitial(name) {
      if (!name) return '?';
      var s = String(name).trim();
      if (!s) return '?';
      return s.slice(0, 1).toUpperCase();
    }

    function setText(el, text) {
      if (!el) return;
      el.textContent = text == null ? '' : String(text);
    }

    function isMobile() {
      return mobileMq ? mobileMq.matches : false;
    }

    roots.forEach(function (root) {
      if (root.dataset && root.dataset.moCommentsInit === '1') return;
      if (root.dataset) root.dataset.moCommentsInit = '1';

      var listEl = root.querySelector('[data-list]');
      var statusEl = root.querySelector('[data-status]');
      var countEl = root.querySelector('[data-count]');
      var sortEl = root.querySelector('[data-sort]');

      var navEl = root.querySelector('[data-nav]');
      var backBtn = root.querySelector('[data-back]');
      var navTitle = root.querySelector('[data-nav-title]');
      var fullBtn = root.querySelector('[data-full-thread]');

      var form = root.querySelector('[data-form]');
      var fatherIdInput = root.querySelector('[data-father-id]');
      var replyingBox = root.querySelector('[data-replying]');
      var replyingText = root.querySelector('[data-replying-text]');
      var cancelReplyBtn = root.querySelector('[data-cancel-reply]');

      var endpoint = root.getAttribute('data-endpoint') || '';
      var pageKey = root.getAttribute('data-page-key') || '';
      var requireLogin = root.getAttribute('data-require-login') === 'true';
      var allowReplies = root.getAttribute('data-allow-replies') === 'true';
      var onlyApproved = root.getAttribute('data-only-approved') === 'true';
      var customerId = root.getAttribute('data-customer-id') || '';

      var state = {
        sort: (root.getAttribute('data-default-sort') || 'newest') === 'oldest' ? 'oldest' : 'newest',
        comments: [],
        byId: {},
        children: {},
        stack: []
      };

      if (sortEl) sortEl.value = state.sort;

      function setStatus(message) {
        setText(statusEl, message || '');
      }

      function setCount(n) {
        if (!countEl) return;
        countEl.hidden = false;
        setText(countEl, n + (n === 1 ? ' comment' : ' comments'));
      }

      function setReplyTo(commentId) {
        if (!fatherIdInput) return;
        fatherIdInput.value = commentId || '0';
        if (!replyingBox) return;
        if (commentId && commentId !== '0') {
          replyingBox.hidden = false;
          var target = state.byId && state.byId[commentId] ? state.byId[commentId] : null;
          var name = target && target.customer_name ? String(target.customer_name) : '';
          setText(replyingText, 'Replying to: ' + (name || commentId));
        } else {
          replyingBox.hidden = true;
          setText(replyingText, '');
        }
      }

      function buildIndex(comments) {
        var byId = {};
        var children = {};
        comments.forEach(function (c) {
          byId[c.comment_id] = c;
          var parentId = c.father_id || '0';
          if (!children[parentId]) children[parentId] = [];
          children[parentId].push(c);
        });
        Object.keys(children).forEach(function (k) {
          children[k].sort(byCreatedAt(state.sort));
        });
        state.byId = byId;
        state.children = children;

        state._descMemo = {};
        state._descVisiting = {};
      }

      function clearList() {
        if (!listEl) return;
        while (listEl.firstChild) listEl.removeChild(listEl.firstChild);
      }

      function el(tag, className) {
        var node = document.createElement(tag);
        if (className) node.className = className;
        return node;
      }

      function renderCommentItem(c, opts) {
        var article = el('article', 'mo-comment');
        article.setAttribute('role', 'listitem');
        article.setAttribute('data-comment-id', c.comment_id);

        var avatar = el('div', 'mo-comment__avatar');
        if (c.avatar_url) {
          var img = document.createElement('img');
          img.src = c.avatar_url;
          img.alt = (c.customer_name || 'Guest') + ' avatar';
          img.loading = 'lazy';
          img.decoding = 'async';
          avatar.appendChild(img);
        } else {
          setText(avatar, getInitial(c.customer_name));
        }
        article.appendChild(avatar);

        var body = el('div', 'mo-comment__body');

        var meta = el('div', 'mo-comment__meta');
        var author = el('span', 'mo-comment__author');
        setText(author, c.customer_name || 'Guest');
        meta.appendChild(author);

        if (c.father_id && c.father_id !== '0' && state.byId && state.byId[c.father_id]) {
          var parent = state.byId[c.father_id];
          var parentName = parent && parent.customer_name ? String(parent.customer_name) : '';
          if (parentName) {
            var replyTo = el('span', 'mo-comment__replyto');
            setText(replyTo, '↳ ' + parentName);
            meta.appendChild(replyTo);
          }
        }

        var created = toDate(c.created_at);
        if (created) {
          var time = el('time', 'mo-comment__time');
          time.dateTime = created.toISOString();
          setText(time, created.toLocaleString());
          meta.appendChild(time);
        }
        body.appendChild(meta);

        var content = el('div', 'mo-comment__content');
        setText(content, c.content || '');
        body.appendChild(content);

        var actions = el('div', 'mo-comment__actions');

        if (allowReplies && opts && opts.showReply) {
          var replyBtn = el('button', 'mo-comment__link');
          replyBtn.type = 'button';
          replyBtn.setAttribute('data-reply-to', c.comment_id);
          setText(replyBtn, 'Reply');
          actions.appendChild(replyBtn);
        }

        function descendantCount(id) {
          if (!state._descMemo) state._descMemo = {};
          if (state._descMemo[id] != null) return state._descMemo[id];
          if (!state._descVisiting) state._descVisiting = {};
          if (state._descVisiting[id]) return 0;
          state._descVisiting[id] = true;

          var kids = (state.children[id] || []);
          var total = kids.length;
          for (var i = 0; i < kids.length; i++) {
            total += descendantCount(kids[i].comment_id);
          }

          state._descVisiting[id] = false;
          state._descMemo[id] = total;
          return total;
        }

        var replyCount = descendantCount(c.comment_id);
        if (opts && opts.showOpenThread && replyCount > 0) {
          var openBtn = el('button', 'mo-comment__link');
          openBtn.type = 'button';
          openBtn.setAttribute('data-open-thread', c.comment_id);
          setText(openBtn, replyCount + (replyCount === 1 ? ' reply' : ' replies'));
          actions.appendChild(openBtn);
        }

        body.appendChild(actions);
        article.appendChild(body);
        return article;
      }

      function renderTreeLevel(parentId, depth) {
        var frag = document.createDocumentFragment();
        var items = (state.children[parentId] || []).slice().sort(byCreatedAt(state.sort));
        var maxDepth = 8;

        items.forEach(function (c) {
          var wrap = el('div', 'mo-thread__item');
          wrap.appendChild(renderCommentItem(c, { showReply: true, showOpenThread: depth >= maxDepth }));
          var childCount = (state.children[c.comment_id] || []).length;
          if (childCount > 0 && depth < maxDepth) {
            var childrenWrap = el('div', 'mo-thread__children');
            childrenWrap.appendChild(renderTreeLevel(c.comment_id, depth + 1));
            wrap.appendChild(childrenWrap);
          }
          frag.appendChild(wrap);
        });

        return frag;
      }

      function renderTreeView() {
        clearList();
        if (navEl) navEl.hidden = true;
        setReplyTo('0');
        state.stack = [];

        var roots = (state.children['0'] || []).slice().sort(byCreatedAt(state.sort));
        if (!roots.length) {
          var empty = el('div', 'mo-comments__empty');
          empty.style.padding = '16px';
          empty.style.color = 'var(--mo-muted)';
          setText(empty, 'No comments yet.');
          if (listEl) listEl.appendChild(empty);
          return;
        }

        var container = el('div', 'mo-thread');
        container.appendChild(renderTreeLevel('0', 0));
        if (listEl) listEl.appendChild(container);
      }

      function renderRootMobile() {
        clearList();
        if (navEl) navEl.hidden = true;
        setReplyTo('0');
        state.stack = [];

        var roots = (state.children['0'] || []).slice().sort(byCreatedAt(state.sort));
        if (!roots.length) {
          var empty = el('div', 'mo-comments__empty');
          empty.style.padding = '16px';
          empty.style.color = 'var(--mo-muted)';
          setText(empty, 'No comments yet.');
          if (listEl) listEl.appendChild(empty);
          return;
        }

        roots.forEach(function (c) {
          if (!listEl) return;
          listEl.appendChild(renderCommentItem(c, { showReply: true, showOpenThread: true }));
        });
      }

      function renderThreadView(focusId) {
        clearList();
        if (navEl) navEl.hidden = false;

        var focus = state.byId[focusId];
        if (navTitle) {
          setText(
            navTitle,
            focus ? ('Comment thread: ' + (focus.customer_name || 'Guest')) : 'Comment thread'
          );
        }

        if (focus && focus.comment_id) {
          setReplyTo(focus.comment_id);
        } else {
          setReplyTo('0');
        }

        if (listEl) {
          var thread = el('div', 'mo-thread');

          if (focus) {
            var wrap = el('div', 'mo-thread__item');
            wrap.appendChild(renderCommentItem(focus, { showReply: true, showOpenThread: false }));

            var childCount = (state.children[focusId] || []).length;
            if (childCount > 0) {
              var childrenWrap = el('div', 'mo-thread__children');
              childrenWrap.appendChild(renderTreeLevel(focusId, 1));
              wrap.appendChild(childrenWrap);
            }

            thread.appendChild(wrap);
          } else {
            thread.appendChild(renderTreeLevel(focusId, 1));
          }

          listEl.appendChild(thread);
        }
      }

      function render() {
        if (!listEl) return;
        if (state.stack.length) {
          renderThreadView(state.stack[state.stack.length - 1]);
          return;
        }
        if (isMobile()) {
          renderRootMobile();
          return;
        }
        renderTreeView();
      }

      function withQuery(url, params) {
        var u = new URL(url, window.location.origin);
        Object.keys(params).forEach(function (k) {
          if (params[k] == null) return;
          u.searchParams.set(k, String(params[k]));
        });
        return u.toString();
      }

      function load() {
        if (!endpoint) {
          setStatus('Missing endpoint (submit_endpoint).');
          return Promise.resolve();
        }
        setStatus('Loading...');
        var url = withQuery(endpoint, {
          page_key: pageKey,
          only_approved: onlyApproved ? 'true' : 'false'
        });
        return fetch(url, { method: 'GET' })
          .then(function (res) {
            if (!res.ok) throw new Error('http_' + res.status);
            return res.json().catch(function () { return {}; });
          })
          .then(function (data) {
            if (data && data.ok === false) throw new Error(data.error || 'load_failed');
            state.comments = (data && data.comments) ? data.comments : [];
            buildIndex(state.comments);
            setCount(state.comments.length);
            setStatus('');
            render();
          })
          .catch(function (err) {
            setStatus('Failed to load: ' + (err && err.message ? err.message : 'unknown'));
          });
      }

      if (sortEl) {
        sortEl.addEventListener('change', function () {
          state.sort = sortEl.value === 'oldest' ? 'oldest' : 'newest';
          buildIndex(state.comments);
          render();
        });
      }

      if (backBtn) {
        backBtn.addEventListener('click', function () {
          state.stack.pop();
          render();
        });
      }

      if (fullBtn) {
        fullBtn.addEventListener('click', function () {
          state.stack = [];
          render();
        });
      }

      if (cancelReplyBtn) {
        cancelReplyBtn.addEventListener('click', function () {
          setReplyTo('0');
        });
      }

      root.addEventListener('click', function (e) {
        var target = e && e.target && e.target.closest ? e.target.closest('[data-open-thread],[data-reply-to]') : null;
        if (!target) return;

        var openId = target.getAttribute('data-open-thread');
        if (openId) {
          state.stack.push(openId);
          render();
          return;
        }

        var replyTo = target.getAttribute('data-reply-to');
        if (replyTo) {
          setReplyTo(replyTo);
          var textarea = form ? form.querySelector('[name="content"]') : null;
          if (textarea && textarea.focus) textarea.focus();
        }
      });

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (requireLogin && !customerId) {
            setStatus('Please log in to comment.');
            return;
          }
          if (!endpoint) {
            setStatus('Missing endpoint (submit_endpoint).');
            return;
          }

          var contentEl = form.querySelector('[name="content"]');
          var content = contentEl ? contentEl.value : '';
          if (!content || !String(content).trim()) {
            setStatus('Please enter a comment.');
            return;
          }

          var payload = {
            page_key: pageKey,
            content: String(content).trim(),
            father_id: fatherIdInput ? fatherIdInput.value : '0'
          };

          setStatus('Submitting...');
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          })
            .then(function (res) {
              if (!res.ok) throw new Error('http_' + res.status);
              return res.json().catch(function () { return {}; });
            })
            .then(function (data) {
              if (data && data.ok === false) throw new Error(data.error || 'submit_failed');
              if (contentEl) contentEl.value = '';
              setReplyTo('0');
              return load();
            })
            .catch(function (err) {
              setStatus('Submit failed: ' + (err && err.message ? err.message : 'unknown'));
            });
        });
      }

      load();

      if (mobileMq) {
        var handler = function () {
          if (!state.stack.length) render();
        };
        if (mobileMq.addEventListener) mobileMq.addEventListener('change', handler);
        else if (mobileMq.addListener) mobileMq.addListener(handler);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
